import Vue from 'vue';
import types from '../../mutation-types';

export const mutations = {
  [types.SET_CONTACT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_CONTACTS]: ($state) => {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
  },
  [types.SET_CONTACT_META]: ($state, data) => {
    const { count, current_page: currentPage } = data;
    Vue.set($state.meta, 'count', count);
    Vue.set($state.meta, 'currentPage', currentPage);
  },

  [types.SET_CONTACTS]: ($state, data) => {
    const sortOrder = data.map((contact) => {
      Vue.set($state.records, contact.id, {
        ...($state.records[contact.id] || {}),
        ...contact,
      });
      return contact.id;
    });
    $state.sortOrder = sortOrder;
  },

  // Stores the record without placing it in the list. sortOrder is paginated
  // and sorted server-side, so appending would put a row out of order and past
  // any active segment. Use ADD_CONTACT_TO_LIST to add one deliberately.
  [types.SET_CONTACT_ITEM]: ($state, data) => {
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });
  },

  [types.ADD_CONTACT_TO_LIST]: ($state, id) => {
    if (!$state.sortOrder.includes(id)) {
      $state.sortOrder.push(id);
    }
  },

  [types.SET_INBOXES]: ($state, data) => {
    $state.inboxes = data;
  },

  [types.EDIT_CONTACT]: ($state, data) => {
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });
  },

  [types.DELETE_CONTACT]: ($state, id) => {
    const index = $state.sortOrder.findIndex((item) => item === id);
    Vue.delete($state.sortOrder, index);
    Vue.delete($state.records, id);
  },

  [types.UPDATE_CONTACTS_PRESENCE]: ($state, data) => {
    Object.values($state.records).forEach((element) => {
      const availabilityStatus = data[element.id];
      if (availabilityStatus) {
        Vue.set(
          $state.records[element.id],
          'availability_status',
          availabilityStatus
        );
      } else {
        Vue.delete($state.records[element.id], 'availability_status');
      }
    });
  },

  [types.SET_CONTACT_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },

  [types.CLEAR_CONTACT_FILTERS](_state) {
    _state.appliedFilters = [];
  },

  [types.SET_CONTACT_CONDITION](_state, data) {
    _state.appliedCondition = data;
  },

  [types.CLEAR_CONTACT_CONDITION](_state) {
    _state.appliedCondition = {};
  },

  [types.SET_ALL_CONTACTS](_state, data) {
    _state.allRecords = data;
  },

  [types.CLEAR_ALL_CONTACTS](_state) {
    _state.allRecords = [];
  },

  [types.SET_ALL_CONTACTS_META](_state, data) {
    _state.allMeta = data;
  },

  [types.CLEAR_ALL_CONTACTS_META](_state) {
    _state.allMeta = {};
  },
};
